import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PasswordResetSuccess = () => {
    const { t } = useTranslation();

    return (
        <div className="container-fluid">  
            <div className="row mt-5 pt-5 justify-content-center">
                <div className="col-lg-6">
                    <div className="text-center">
                        <h1>{t('login.passwordResetSuccessful')}</h1>
                        <p>
                            {t('login.passwordResetSuccessfulMessage')}
                        </p>
                        <Link to="/login" className="btn btn-primary">{t('login.login')}</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasswordResetSuccess;
